import { LogOut, Bell } from 'lucide-react';
import { useAgentStore } from '../../store/agentStore';
import { useAgentAuth } from '../../hooks/useAgentAuth';
import { useNotificationStore } from '../../store/notificationStore';
import { NotificationPanel } from '../common/NotificationPanel';

export const AgentHeader = () => {
  const { agent, user } = useAgentStore();
  const { logout } = useAgentAuth();
  const { unreadCount, togglePanel } = useNotificationStore();

  // Obtener el nombre para mostrar y la inicial
  const displayName = agent?.businessName || `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'Agente';
  const initial = displayName.charAt(0).toUpperCase();
  const agentCode = agent?.agentCode || 'N/A';

  return (
    <header className="bg-white border-b border-gray-200 safe-top">
      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo / Business Name */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary-600 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-lg">
                {initial}
              </span>
            </div>
            <div>
              <h1 className="text-lg font-semibold text-gray-900">
                {displayName}
              </h1>
              <p className="text-xs text-gray-500">Código: {agentCode}</p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2">
            <button
              onClick={togglePanel}
              className="p-2 text-gray-600 hover:text-primary-600 transition-colors relative"
              title="Notificaciones"
            >
              <Bell size={22} />
              {unreadCount > 0 && (
                <span className="absolute -top-0.5 -right-0.5 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-bold leading-none">
                  {unreadCount > 9 ? '9+' : unreadCount}
                </span>
              )}
            </button>
            <button
              onClick={logout}
              className="p-2 text-gray-600 hover:text-danger-600 transition-colors"
              title="Cerrar sesión"
            >
              <LogOut size={22} />
            </button>
          </div>
        </div>
      </div>
      <NotificationPanel />
    </header>
  );
};
